import React, { useState, useEffect } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import dataBanner from '../assets/data/data-banner';
import dataManfaat from '../assets/data/dataManfaat';
import dataPerkhidmatan from '../assets/data/dataPerkhidmatan';
import Manfaat from '../components/banner/ManfaatAJ';
import Banner01 from '../components/banner/Banner01';
import YouTubeVideo from '../components/Video/YouTubeVideo';
import CTA from '../components/cta';
import PerkhidmatanKami from '../components/liveautions/PerkhidmatanKami';
import HomePopup from '../components/popup/HomePopup';
import samplePDF from '../assets/images/Risalah-Al-Jariyah2.pdf';
import samplePDF2 from '../assets/images/Brochure.pdf';

function Home01(props) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isSecondPopupOpen, setIsSecondPopupOpen] = useState(false);

    // const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: (Toolbar) => (
        <Toolbar>
            {(slots) => (
                <>
                    {slots.Open}
                    {slots.CurrentPageInput}
                    {slots.GoToPreviousPage}
                    {slots.GoToNextPage}
                    {slots.PageIndicator}

                    {/* Explicitly include zoom tools */}
                    {slots.ZoomOut}
                    {slots.ZoomPopover}
                    {slots.ZoomIn}

                    {slots.SwitchTheme}
                    {slots.Search}
                    {/* Do NOT include: slots.Download, slots.Print */}
                </>
            )}
        </Toolbar>
    ),});



    useEffect(() => {
        const timer = setTimeout(() => {
            setIsPopupOpen(true); 
        }, 1000);

        return () => clearTimeout(timer); 
    }, []);

    
    useEffect(() => {
        if (isPopupOpen || isSecondPopupOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto'; 
        };
    }, [isPopupOpen, isSecondPopupOpen]);

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setTimeout(() => {
            setIsSecondPopupOpen(true); 
        }, 1000);
    };

    const handleCloseSecondPopup = () => setIsSecondPopupOpen(false);

    return (
        <div className="home-1">
            <div id="page">
                {/* First Popup */}
                <HomePopup
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    content={
                        <div style={{ textAlign: 'center', width: '100%', height: '100%' }}>
                            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                                <Viewer fileUrl={samplePDF} />
                            </Worker>
                        </div>
                    }
                />

                {/* Second Popup */}
                <HomePopup
                    isOpen={isSecondPopupOpen}
                    onClose={handleCloseSecondPopup}
                    content={
                        <div style={{ textAlign: 'center', width: '100%', height: '100%' }}>
                            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                                <Viewer fileUrl={samplePDF2} />
                            </Worker>
                        </div>
                    }
                />
                
                <Banner01 data={dataBanner} />

                {/* <YouTubeVideo
                    videoUrl="https://al-jariyah.com/assets/images/kempen/BannerRayaAJ.mp4"
                    title="Selamat Hari Raya Aidilfitri 2025"
                    description="Selamat Hari Raya Aidilfitri 2025"
                /> */}
                <PerkhidmatanKami data={dataPerkhidmatan} />
                <Manfaat data={dataManfaat} />
                <CTA />
            </div>
        </div>
    );
}

export default Home01;
